import styled from "styled-components"
import { Divider } from "@material-ui/core"

const StyledDivider = styled(Divider)`
  margin: 1rem 16px !important;
`

export default StyledDivider
